import React from 'react';


import Animation from "../animation/animation";
import Card from "../card/card";
import ContactFormCn from "../contact-form/contact-form-cn";
import Grid from "../grid/grid";
import GridLine from "../grid-line/grid-line";
import ProjectSliderCn from "../project-slider/project-slider-cn";

import './services.scss';

import automationVideo from '../../f/videos/automation.mp4';
import automationCover from '../../f/img/automation.jpg';
import brandingVideo from '../../f/videos/branding.mp4';
import brandingCover from '../../f/img/branding.jpg';
import grafVideo from '../../f/videos/graf.mp4';
import grafCover from '../../f/img/graf.jpg';
import interfaceVideo from '../../f/videos/interface.mp4';
import interfaceCover from '../../f/img/interface.jpg';
import interiorVideo from '../../f/videos/interior.mp4';
import interiorCover from '../../f/img/interior.jpg';
import navigationVideo from '../../f/videos/navigation.mp4';
import navigationCover from '../../f/img/navigation.jpg';
import prVideo from '../../f/videos/pr.mp4';
import prCover from '../../f/img/pr.jpg';
import promVideo from '../../f/videos/prom.mp4';
import promCover from '../../f/img/prom.jpg';
import smmVideo from '../../f/videos/smm.mp4';
import smmCover from '../../f/img/smm.jpg';
import strategiesVideo from '../../f/videos/strategies.mp4';
import strategiesCover from '../../f/img/strategies.jpg';
import urbanVideo from '../../f/videos/urban.mp4';
import urbanCover from '../../f/img/urban.jpg';
import webVideo from '../../f/videos/web.mp4';
import webCover from '../../f/img/web.jpg';
import inclusiveVideo from '../../f/videos/inclusive.mp4';
import inclusiveCover from '../../f/img/inclusive.jpg';



const ServicesCn = () => {
	return (
		<React.Fragment>
			<div className="services category-list">
				<div className="services-header">
					{/* <h1 className="services-header__text">资质 <br/> Art. Lebedev Studio</h1> */}

					<Animation header="整体形象、建筑、网页、视频、平面设计、城市环境、插画、室内设计、界面、书籍、标识、移动应用、运动设计、导视、图案、演示、工业设计、广告、字体、外观设计"/>
					<div className="als-text-container">
						<h1 className="services-container__header">资质 <br/> Art. Lebedev Studio</h1>
						<p className="services__text">
							我们致力于为各类企业寻找到完美解决问题的方式，并让设计创造更美好的生活。
						</p>
					</div>
				</div>
				<div className="services-main">
					<Grid>
						<GridLine>
							<Card
								url="/competencies/graf/?lang=cn"
								type="video"
								previewContent={automationVideo}
								poster={automationCover}
								title="设计自动化与人工智能"
								description="与尼古拉·艾诺夫合作，高速布局。大型设计系统，横幅生成器，专供品牌书籍和社交媒体的模板引擎。"
							/>
							<Card
								url="/competencies/branding/?lang=cn"
								type="video"
								previewContent={brandingVideo}
								poster={brandingCover}
								title="品牌的创立与重塑"
								description="整体形象、取名、品牌书、品牌平台与标识设计。专为初创公司打造的快速设计体系。"
							/>
							<Card
								url="/competencies/urban/?lang=cn"
								type="video"
								previewContent={urbanVideo}
								poster={urbanCover}
								title="城市设计与城市主义设计"
								description="建筑与景观设计、艺术装置、创立地方品牌形象、城市公共设计。立面装饰、城市设施及装置。"
							/>
							<Card
								url="/competencies/graf/?lang=cn"
								type="video"
								previewContent={grafVideo}
								poster={grafCover}
								title="图像创意与设计"
								description="外包装设计、插图、图案、海报、字体、3D动画制作。"
							/>
							{/*<Card*/}
							{/*    url="/competencies/inclusive"*/}
							{/*    type="video"*/}
							{/*    previewContent={inclusiveVideo}*/}
							{/*    poster={inclusiveCover}*/}
							{/*    title="Inclusive design"*/}
							{/*    description="Adapting sites for people with visual and hearing disabilities, creating a&nbsp;friendly
                {/*    environment, designing specialist devices, designing for engagement."*/}
							{/*/>*/}
							<Card
								url="/competencies/interior/?lang=cn"
								type="video"
								previewContent={interiorVideo}
								poster={interiorCover}
								title="室内室与外设计"
								description="室内设计如办公室、商店、展位、橱窗与标识设计。室外设计如大型生产设施的外观设计与绝佳的城市立面设计。"
							/>
							<Card
								url="/competencies/navigation/?lang=cn"
								type="video"
								previewContent={navigationVideo}
								poster={navigationCover}
								title="导视系统"
								description="用于交通、公园、购物中心、办公室、仓库以及医疗机构的导航系统、标志、指针、地图及图表设计。"
							/>
							<Card
								url="/competencies/pr/?lang=cn"
								type="video"
								previewContent={prVideo}
								poster={prCover}
								title="促销与公关"
								description="媒体创意策略，博客广告植入，数字社交媒体的定向广告，公关支持。"
							/>
							<Card
								url="/competencies/prom/?lang=cn"
								type="video"
								previewContent={promVideo}
								poster={promCover}
								title="工业设计"
								description="囊括各类工业产品设计，如家具、配件、工具、电子设备、交通工具、城市与街道的公共设施设计。"
							/>
							<Card
								url="/competencies/interface/?lang=cn"
								type="video"
								previewContent={interfaceVideo}
								poster={interfaceCover}
								title="应用程序与界面设计"
								description="移动应用设计、信息系统界面设计、取款机设计与其终端设计、AR和VR应用设计、UI/UX设计。"
							/>
							<Card
								url="/competencies/web/?lang=cn"
								type="video"
								previewContent={webVideo}
								poster={webCover}
								title="网站设计"
								description="促销网站与登陆页设计，互动设计，公司宣发网站设计，企业内联网与在线商店设计。"
							/>
							{/*<Card*/}
							{/*    url="/competencies/smm"*/}
							{/*    type="video"*/}
							{/*    previewContent={smmVideo}*/}
							{/*    poster={smmCover}*/}
							{/*    title="СММ и контент"*/}
							{/*    description="Стратегии ведения аккаунтов и&nbsp;автоматизация шаблонов, подборка авторов и&nbsp;копирайтинг, визуальный контент и&nbsp;оформление страниц в&nbsp;соцмедиа."*/}
							{/*/>*/}
						</GridLine>
					</Grid>
				</div>
				<ProjectSliderCn />
				{/*<Animation type="words" />*/}
				<ContactFormCn formId="other"/>
			</div>
		</React.Fragment>
	);
}

export default ServicesCn;
